import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { CONTENT, BOOK_APPOINTMENT, CHECK_SYMPTOMS, PRESCRIPTION } = USA
const { WELCOME, REGISTRATION, SUMMARY } = CONTENT

const partnerName = 'California Health & Wellness'

const healthAndWellness: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    id: 'health-and-wellness',
    productConfigAppName: 'health-and-wellness',
    name: partnerName,
    codes: {
      membership: 'CHWMC',
    },
    partnerUrlSlug: 'chw',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: (WELCOME.enUS.copy as CopyFunction)(partnerName),
          productFeatures: [
            CHECK_SYMPTOMS.enUS,
            {
              ...BOOK_APPOINTMENT.enUS,
              title:
                'Book a video appointment to talk to a physician 24 hours a day, 7 days a week or a therapist Monday - Friday 7am-7pm',
            },
            {
              ...PRESCRIPTION.enUS,
              title:
                'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
            },
          ],
        },
        {
          ...REGISTRATION.enUS,
          copy: ['Enter your details to get our services'],
        },
        {
          ...SUMMARY.enUS,
          cta: {
            showDownloadButtons: true,
            label: 'Questions? Contact us →',
            link: DEFAULT.FAQs.USA,
          },
          copy: [
            'Download the Babylon app and sign in to book a video appointment at no cost through your health plan',
          ],
          contactDetails: [
            'Need help with the app or would like to cancel your account, please call 1-800-475-6168 (TTY:711) 5 AM to 7 PM (PST), 7 days a week or email us-support@babylonhealth.com.',
            'For questions about your health plan, please call 1-877-658-0305 (TTY/TDD: 711), 8 a.m. to 5 p.m., Monday-Friday ',
          ],
        },
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const healthAndWellnessWithDnaV2Design: PartnerConfig = {
  ...healthAndWellness,
  config: {
    ...healthAndWellness.config,
    useDnaV2Design: true,
  },
}

export default [healthAndWellness, healthAndWellnessWithDnaV2Design]
